import { render } from "./BloodPressure.vue?vue&type=template&id=568681a8&scoped=true"
import script from "./BloodPressure.vue?vue&type=script&lang=js"
export * from "./BloodPressure.vue?vue&type=script&lang=js"

import "./BloodPressure.vue?vue&type=style&index=0&id=568681a8&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568681a8"]])

export default __exports__